module.exports = __webpack_public_path__ + "img/4064009390.cffa5d86.jpg";